export type Kana = {
  hiragana: string
  katakana: string
  romaji: string
}

export const gojuonData: { [key: string]: Kana[] } = {
  'あ行': [
    { hiragana: 'あ', katakana: 'ア', romaji: 'a' },
    { hiragana: 'い', katakana: 'イ', romaji: 'i' },
    { hiragana: 'う', katakana: 'ウ', romaji: 'u' },
    { hiragana: 'え', katakana: 'エ', romaji: 'e' },
    { hiragana: 'お', katakana: 'オ', romaji: 'o' },
  ],
  'か行': [
    { hiragana: 'か', katakana: 'カ', romaji: 'ka' },
    { hiragana: 'き', katakana: 'キ', romaji: 'ki' },
    { hiragana: 'く', katakana: 'ク', romaji: 'ku' },
    { hiragana: 'け', katakana: 'ケ', romaji: 'ke' },
    { hiragana: 'こ', katakana: 'コ', romaji: 'ko' },
  ],
  'さ行': [
    { hiragana: 'さ', katakana: 'サ', romaji: 'sa' },
    { hiragana: 'し', katakana: 'シ', romaji: 'shi' },
    { hiragana: 'す', katakana: 'ス', romaji: 'su' },
    { hiragana: 'せ', katakana: 'セ', romaji: 'se' },
    { hiragana: 'そ', katakana: 'ソ', romaji: 'so' },
  ],
  'た行': [
    { hiragana: 'た', katakana: 'タ', romaji: 'ta' },
    { hiragana: 'ち', katakana: 'チ', romaji: 'chi' },
    { hiragana: 'つ', katakana: 'ツ', romaji: 'tsu' },
    { hiragana: 'て', katakana: 'テ', romaji: 'te' },
    { hiragana: 'と', katakana: 'ト', romaji: 'to' },
  ],
  'な行': [
    { hiragana: 'な', katakana: 'ナ', romaji: 'na' },
    { hiragana: 'に', katakana: 'ニ', romaji: 'ni' },
    { hiragana: 'ぬ', katakana: 'ヌ', romaji: 'nu' },
    { hiragana: 'ね', katakana: 'ネ', romaji: 'ne' },
    { hiragana: 'の', katakana: 'ノ', romaji: 'no' },
  ],
  'は行': [
    { hiragana: 'は', katakana: 'ハ', romaji: 'ha' },
    { hiragana: 'ひ', katakana: 'ヒ', romaji: 'hi' },
    { hiragana: 'ふ', katakana: 'フ', romaji: 'fu' },
    { hiragana: 'へ', katakana: 'ヘ', romaji: 'he' },
    { hiragana: 'ほ', katakana: 'ホ', romaji: 'ho' },
  ],
  'ま行': [
    { hiragana: 'ま', katakana: 'マ', romaji: 'ma' },
    { hiragana: 'み', katakana: 'ミ', romaji: 'mi' },
    { hiragana: 'む', katakana: 'ム', romaji: 'mu' },
    { hiragana: 'め', katakana: 'メ', romaji: 'me' },
    { hiragana: 'も', katakana: 'モ', romaji: 'mo' },
  ],
  'や行': [
    { hiragana: 'や', katakana: 'ヤ', romaji: 'ya' },
    { hiragana: 'ゆ', katakana: 'ユ', romaji: 'yu' },
    { hiragana: 'よ', katakana: 'ヨ', romaji: 'yo' },
  ],
  'ら行': [
    { hiragana: 'ら', katakana: 'ラ', romaji: 'ra' },
    { hiragana: 'り', katakana: 'リ', romaji: 'ri' },
    { hiragana: 'る', katakana: 'ル', romaji: 'ru' },
    { hiragana: 'れ', katakana: 'レ', romaji: 're' },
    { hiragana: 'ろ', katakana: 'ロ', romaji: 'ro' },
  ],
  'わ行': [
    { hiragana: 'わ', katakana: 'ワ', romaji: 'wa' },
    { hiragana: 'ゐ', katakana: 'ヰ', romaji: 'wi' }, // 歷史假名，romaji 為 "wi"，但發音與 い 相同（音檔使用 "i"）
    { hiragana: 'ゑ', katakana: 'ヱ', romaji: 'we' }, // 歷史假名，romaji 為 "we"，但發音與 え 相同（音檔使用 "e"）
    { hiragana: 'を', katakana: 'ヲ', romaji: 'wo' },
    { hiragana: 'ん', katakana: 'ン', romaji: 'n' },
  ],
}

// 濁音和半濁音
export const dakutenData: { [key: string]: Kana[] } = {
  'が行': [
    { hiragana: 'が', katakana: 'ガ', romaji: 'ga' },
    { hiragana: 'ぎ', katakana: 'ギ', romaji: 'gi' },
    { hiragana: 'ぐ', katakana: 'グ', romaji: 'gu' },
    { hiragana: 'げ', katakana: 'ゲ', romaji: 'ge' },
    { hiragana: 'ご', katakana: 'ゴ', romaji: 'go' },
  ],
  'ざ行': [
    { hiragana: 'ざ', katakana: 'ザ', romaji: 'za' },
    { hiragana: 'じ', katakana: 'ジ', romaji: 'ji' },
    { hiragana: 'ず', katakana: 'ズ', romaji: 'zu' },
    { hiragana: 'ぜ', katakana: 'ゼ', romaji: 'ze' },
    { hiragana: 'ぞ', katakana: 'ゾ', romaji: 'zo' },
  ],
  'だ行': [
    { hiragana: 'だ', katakana: 'ダ', romaji: 'da' },
    { hiragana: 'ぢ', katakana: 'ヂ', romaji: 'ji' },
    { hiragana: 'づ', katakana: 'ヅ', romaji: 'zu' },
    { hiragana: 'で', katakana: 'デ', romaji: 'de' },
    { hiragana: 'ど', katakana: 'ド', romaji: 'do' },
  ],
  'ば行': [
    { hiragana: 'ば', katakana: 'バ', romaji: 'ba' },
    { hiragana: 'び', katakana: 'ビ', romaji: 'bi' },
    { hiragana: 'ぶ', katakana: 'ブ', romaji: 'bu' },
    { hiragana: 'べ', katakana: 'ベ', romaji: 'be' },
    { hiragana: 'ぼ', katakana: 'ボ', romaji: 'bo' },
  ],
  'ぱ行': [
    { hiragana: 'ぱ', katakana: 'パ', romaji: 'pa' },
    { hiragana: 'ぴ', katakana: 'ピ', romaji: 'pi' },
    { hiragana: 'ぷ', katakana: 'プ', romaji: 'pu' },
    { hiragana: 'ぺ', katakana: 'ペ', romaji: 'pe' },
    { hiragana: 'ぽ', katakana: 'ポ', romaji: 'po' },
  ],
}